<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'productMananger' }">商品管理</el-breadcrumb-item>
            <el-breadcrumb-item>编辑商品</el-breadcrumb-item>
        </el-breadcrumb>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="first">
                <el-form  :model="actForm" :rules="actrules" ref="actForm" label-width="150px" class="demo-ruleForm" >

                    <el-form-item label="商品名称" prop="productName">
                        <el-input v-model="actForm.productName" placeholder="商品名称" style="width: 60%;" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="商品图片" prop="fileList" style="width: 40%;">
                        <img :src="actForm.Image" class="avatar" style="height: 150px;">
                        <!--<el-upload-->
                                <!--class="upload-demo"-->
                                <!--ref="upload"-->
                                <!--:action="uploadurl"-->
                                <!--:data="upload_data"-->
                                <!--:on-preview="handlePreview"-->
                                <!--:on-remove="handleRemove"-->
                                <!--:on-success="handleSuccess"-->
                                <!--:before-upload="handletype"-->
                                <!--:file-list="actForm.fileList"-->
                                <!--list-type="picture"-->
                        <!--&gt;-->
                    <!--<span v-bind:class="{isable:isorno}">-->
                            <!--<el-button size="small" type="success">选择图片</el-button>-->
                            <!--<div slot="tip" class="el-upload__tip">大小不超过5MB</div>-->
                        <!--</span>-->
                        <!--</el-upload>-->
                    </el-form-item>

                    <el-form-item label="品类" prop="categoriesName">
                        <el-input v-model="actForm.categoriesName" placeholder="品类" style="width: 60%;" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="售货机价格" prop="price">
                        <el-input v-model="actForm.price" placeholder="售货机价格" style="width: 60%;" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="线上价格" prop="ppwprice">
                        <el-input v-model="actForm.ppwprice" placeholder="线上价格" style="width: 60%;" :disabled="this.radio == true"></el-input>
                        <el-checkbox v-model="radio" @change="priceAcc()">与售货机价格保持一致</el-checkbox>
                    </el-form-item>

                    <el-form-item label="库存" prop="available">
                        <el-input v-model="actForm.available" placeholder="库存" style="width: 60%;" ></el-input>
                    </el-form-item>

                    <!--<el-form-item>-->
                        <!--<el-button type="primary"  @click="submitForm('actForm')" id="primary" :disabled="isorgsubmit">保 存</el-button>-->
                        <!--<el-button @click="resetForm('actForm')">重 置</el-button>-->
                    <!--</el-form-item>-->

                </el-form>
            </el-tab-pane>

            <el-tab-pane label="商品详情" name="second">
                <div>
                    <mavon-editor v-model="value" :defaultOpen="defaultData" @change="changeData"
                                  :ishljs = "true"
                                  ref=md @imgAdd="$imgAdd" @imgDel="$imgDel" :toolbars="toolbars"/>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div>
            <el-button type="primary"  @click="submitForm('actForm')" id="primary" :disabled="isorgsubmit">保 存</el-button>
            <el-button @click="resetForm()">关 闭</el-button>
        </div>

    </div>

</template>
<script>
    import { quillEditor } from "vue-quill-editor"; //调用编辑器
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    export default {
        components: {
            quillEditor
        },
        data() {
            return {
                isorno:false,
                isorgsubmit:false,
                uploadurl:this.fileURL+"/vueFeign/UplodFile",
                url:this.productURL+"/vueFeign/update/ProductInfo",
                infourl: this.productURL+"/vueFeign/getProductPutaway",
                updateurl:this.productURL+"/vueFeign/update/ProInfo",
                activeName: 'first',
                radio: false,
                value: '',
                defaultData: "preview",
                actForm:{
                    productName:'',
                    categoriesName:'',
                    available:'',
                    Image:'',
                    price:'',
                    ppwprice:'',
                    fileList:[],
                },
                actrules: {

                },
                upload_data:{
                    type:this.apkUploadWay,
                    folder:"app"
                },
                toolbars: {
                    bold: true, // 粗体
                    italic: true,// 斜体
                    underline: true,// 下划线
                    imagelink: true,// 图片链接
                    subfield: true,// 是否需要分栏
                    readmodel: true,// 沉浸式阅读
                    htmlcode: true,// 展示html源码
                    help: true// 帮助
                },
            };
        },
        created(){
            this.actForm.productName = this.$route.query.productName;
            this.actForm.price = this.$route.query.price;
            this.actForm.ppwprice = this.$route.query.ppwPrice;
            this.actForm.categoriesName = this.$route.query.categoriesName;
            this.actForm.available = this.$route.query.available;
            this.actForm.Image = this.$route.query.Image;
            if(this.actForm.price == this.actForm.ppwprice){
                this.radio = true;
            }else {
                this.radio = false;
            }
            this.getData();
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            /*handlePreview(file) {
            },
            handleRemove(file, fileList) {
                this.isorno=false;
                this.actForm.fileList = fileList;
            },
            handleSuccess(response, file, fileList){
                this.actForm.fileList = fileList;
                console.log(this.actForm.fileList);
            },*/
            resetForm() {
                this.changeData();
                this.$router.push( {path:"productMananger"})
            },
           /* handletype(file) {
                var n = file.name.split(".");
                var len = n.length;
                var type = n[len - 1];

                if (type !== "jpeg" && type !== "jpg" && type !== "png" && type !== "gif") {
                    this.$message({showClose: true, message: '只能选择图片', type: 'error'});
                    this.clear("upload");
                    return false;
                }else {
                    var _this = this;
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        let data = e.target.result;
                        let img = new Image();
                        img.src = data;
                        img.onload = function () {
                            console.log(img.width+"======"+img.height)
                            if (img.width == 1080 && img.height == 3067) {

                                return true;
                            } else {
                                _this.actForm.fileList = [];
                                _this.$message({
                                    showClose: true,
                                    message: '图片尺寸不能大小于' + 1080 + '*' + 3067,
                                    type: 'error'
                                });
                                _this.clear("upload");
                                _this.isorno = false;
                                return false;
                            }
                            ;
                        }
                    }
                    reader.readAsDataURL(file)
                }
            },*/
            /**-----------图文编辑器--------------**/
            changeData(value, render) {
                var kiosk = this.$route.query.kioskNo
                var SKU = this.$route.query.SKU
                    setTimeout(() =>{
                            if((render.split('img')).length-1 == (render.split('https://antgine-migu.oss-cn-hangzhou.aliyuncs.com/')).length-1){
                                var params = {kioskNo:kiosk,proInfo:render,SKU: SKU};
                                this.$http.post(this.updateurl,params)
                                    .then(response => {
                                        if (response.status === 200) {
                                            if(response.body.Code=='200'){

                                            }else{
                                                this.$message({ showClose: true, message: "服务器错误",  type: 'error' });
                                            }
                                        }
                                    },function(response){
                                        this.$message({
                                            showClose: true,
                                            message: '网络异常',
                                            type: 'error'

                                        });
                                    })
                            }
                    },4000);
            },
            // 绑定@imgAdd event
            $imgAdd(pos, $file) {
                // 第一步.将图片上传到服务器.
                var formdata = new FormData();
                formdata.append('file', $file);
                this.$http.post(this.uploadurl,formdata).then((response)=>{
                    console.log(response)
                    var data=response.body;
                    if(data.code=="200"){
                        this.$refs.md.$img2Url(pos, response.data.path);
                    }else{
                        this.$message({showClose: true,message: '上传图片失败',type: 'error'});
                    }
                },()=>{
                    this.$message({showClose: true,message: '网络异常',type: 'error'});
                })

            },
            $imgDel(pos) {
                delete this.img_file[pos];
            },
            priceAcc(){
                if(this.radio){
                    this.actForm.ppwprice = this.actForm.price;
                }else {
                    this.actForm.ppwprice = this.$route.query.ppwPrice;
                }
            },
            submitForm(formName) {
                this.changeData();
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var num = this.actForm.fileList.length;
                        var fileStr = "";
                        if(num > 0){
                            for (var i = 0;i<num;i++){
                                fileStr += this.actForm.fileList[i].response.path+","
                            }
                        }
                        console.log(fileStr);
                        var params={SKU: this.$route.query.SKU,kioskNo: this.$route.query.kioskNo,price:this.actForm.ppwprice,fileList:fileStr,
                            available:this.actForm.available}
                        this.$http.post(this.url,params).then((response)=>{
                            var data=response.body;
                            if(data.Code=="200"){
                                this.$message({showClose: true,message: '修改成功',type: 'success'});
                            }else{
                                this.$message({showClose: true,message: '参数错误',type: 'error'});
                            }
                        },()=>{
                            this.$message({showClose: true,message: '网络异常',type: 'error'});
                        })

                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            getData(){
                var params = {tenantId:this.getcookie('storeId'),kioskNo:this.$route.query.kioskNo,SKU: this.$route.query.SKU};
                this.$http.post(this.infourl,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                if(response.body.Data.productImg.length > 0){
                                    this.value = response.body.Data.productImg[0].proInfo
                                }

                            }else{
                                this.$message({ showClose: true, message: "服务器错误",  type: 'error' });
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        }
    };
</script>
<style>
    .div-inline{
        display:inline;
    }
</style>


// WEBPACK FOOTER //
// productModify.vue?540012db